export default function Lotes() {
    return(
        <div>
            <h1>Lotes</h1>
            <p>Descrever funcionalidades</p>
        </div>
    )
}